var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXpLevel8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3066",
    "data-name": "Group 3066",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48.369,
    height: 46.804,
    viewBox: "0 0 48.369 46.804",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1430",
    "data-name": "Rectangle 1430",
    width: 48.369,
    height: 46.804,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3065",
    "data-name": "Group 3065",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33088",
    "data-name": "Path 33088",
    d: "M67.188,10.711A34.057,34.057,0,0,0,53.456,8.1a33.737,33.737,0,0,0-13.974,2.721l-3.87-1.258V34.139a17.834,17.834,0,1,0,35.667,0V9.565Z",
    transform: "translate(-29.26 -6.657)",
    fill: "#dd916f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33089",
    "data-name": "Path 33089",
    d: "M69,12.3l7.3,6.792,4.465,8.42L84.262,19.9,92.5,12.577,79.842,10.717Z",
    transform: "translate(-56.697 -8.805)",
    fill: "#ff7976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33090",
    "data-name": "Path 33090",
    d: "M51.5,52.515a8.917,8.917,0,1,1-7.31-14.477l5.5,6.363Z",
    transform: "translate(-29.261 -31.254)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33091",
    "data-name": "Path 33091",
    d: "M146.548,52.515a8.917,8.917,0,1,0,7.31-14.477l-5.5,6.363Z",
    transform: "translate(-120.413 -31.254)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33092",
    "data-name": "Path 33092",
    d: "M24.184,32.109A1.783,1.783,0,0,1,22.4,30.325c0-14.038-7.9-22.758-20.618-22.758A1.783,1.783,0,0,1,1.783,4c10.942,0,19,5.732,22.4,15.264C27.584,9.733,35.643,4,46.585,4a1.783,1.783,0,0,1,0,3.567c-12.717,0-20.618,8.72-20.618,22.758a1.783,1.783,0,0,1-1.783,1.783",
    transform: "translate(0 -3.287)",
    fill: "#4a4e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33093",
    "data-name": "Path 33093",
    d: "M146.372,50.69a10.272,10.272,0,0,1-8.224-4.069,1.427,1.427,0,0,1,2.268-1.732,7.49,7.49,0,1,0,6.041-12.032A1.427,1.427,0,0,1,146.472,30h.016a10.344,10.344,0,0,1-.116,20.686",
    transform: "translate(-113.271 -24.653)",
    fill: "#4a4e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33094",
    "data-name": "Path 33094",
    d: "M37.954,50.719a10.343,10.343,0,0,1-.4-20.679,1.427,1.427,0,0,1,.108,2.851,7.49,7.49,0,1,0,6.142,12.16,1.427,1.427,0,1,1,2.228,1.783,10.3,10.3,0,0,1-8.08,3.886",
    transform: "translate(-22.687 -24.682)",
    fill: "#4a4e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33095",
    "data-name": "Path 33095",
    d: "M172.744,71.568A3.567,3.567,0,1,1,169.178,68a3.567,3.567,0,0,1,3.567,3.567",
    transform: "translate(-136.077 -55.874)",
    fill: "#4d4e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33096",
    "data-name": "Path 33096",
    d: "M72.744,71.568A3.567,3.567,0,1,1,69.178,68a3.567,3.567,0,0,1,3.567,3.567",
    transform: "translate(-53.91 -55.874)",
    fill: "#4d4e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33097",
    "data-name": "Path 33097",
    d: "M46.871,53.464A19.282,19.282,0,0,1,27.611,34.2V9.63a1.427,1.427,0,1,1,2.853,0V34.2a16.407,16.407,0,0,0,32.814,0V9.63a1.427,1.427,0,0,1,2.853,0V34.2a19.282,19.282,0,0,1-19.26,19.26",
    transform: "translate(-22.687 -6.74)",
    fill: "#4a4e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33098",
    "data-name": "Path 33098",
    d: "M50.738,5.574a1.427,1.427,0,0,1-.609-2.718A35.116,35.116,0,0,1,64.712,0,35.492,35.492,0,0,1,79.035,2.737a1.427,1.427,0,1,1-1.182,2.6,32.615,32.615,0,0,0-13.141-2.48A32.241,32.241,0,0,0,51.345,5.438a1.42,1.42,0,0,1-.607.136",
    transform: "translate(-40.516)",
    fill: "#4a4e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33099",
    "data-name": "Path 33099",
    d: "M64.7,249.3H29.038a1.427,1.427,0,0,1,0-2.853H64.7a1.427,1.427,0,0,1,0,2.853",
    transform: "translate(-22.687 -202.499)",
    fill: "#4a4e59"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1424",
    "data-name": "Rectangle 1424",
    width: 3.567,
    height: 2.497,
    transform: "translate(22.401 30.764)",
    fill: "#a05335"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1425",
    "data-name": "Rectangle 1425",
    width: 3.567,
    height: 2.497,
    transform: "translate(22.401 39.324)",
    fill: "#a05335"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1426",
    "data-name": "Rectangle 1426",
    width: 3.567,
    height: 2.497,
    transform: "translate(25.968 35.044)",
    fill: "#a05335"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1427",
    "data-name": "Rectangle 1427",
    width: 3.567,
    height: 2.497,
    transform: "translate(18.834 35.044)",
    fill: "#a05335"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1428",
    "data-name": "Rectangle 1428",
    width: 3.567,
    height: 2.497,
    transform: "translate(29.534 30.764)",
    fill: "#a05335"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1429",
    "data-name": "Rectangle 1429",
    width: 3.567,
    height: 2.497,
    transform: "translate(15.268 30.764)",
    fill: "#a05335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33100",
    "data-name": "Path 33100",
    d: "M78.018,76.767a.616.616,0,1,1-.617-.617.616.616,0,0,1,.617.617",
    transform: "translate(-63.091 -62.57)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33101",
    "data-name": "Path 33101",
    d: "M86.094,87.1a1.1,1.1,0,1,1-1.1-1.1,1.1,1.1,0,0,1,1.1,1.1",
    transform: "translate(-68.934 -70.664)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33102",
    "data-name": "Path 33102",
    d: "M188.307,76.767a.616.616,0,1,0,.616-.617.616.616,0,0,0-.616.617",
    transform: "translate(-154.725 -62.57)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33103",
    "data-name": "Path 33103",
    d: "M175.785,87.1a1.1,1.1,0,1,0,1.1-1.1,1.1,1.1,0,0,0-1.1,1.1",
    transform: "translate(-144.436 -70.664)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXpLevel8);
export default __webpack_public_path__ + "static/media/xpLevel8.3bcd8f544ba39eb4ab7874f1c25690f8.svg";
export { ForwardRef as ReactComponent };